import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'playerPipe'})
export class PlayerPipe implements PipeTransform
{
  transform(player: any, reverse?: boolean): string
  {
    if (player)
    {
      if (player.displayName)
        return player.displayName;
      if (player.name && player.firstname)
      {
        if (reverse)
          return player.name + ', ' + player.firstname;
        else return player.firstname + ' ' + player.name;
      }
        // return player.name + ', ' + player.firstname;
      if (player.name)
        return player.name;
      if (player.username)
        return player.username;
    }
    return '';
  }
}
